// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"reviews-view_shadow__3r_04","wrapper":"reviews-view_wrapper__2ZSya","empty":"reviews-view_empty__Vm3CM"};